import {UI} from "../../../stem-core/ui/UIBase";

import {AuthPanelPage} from "./AuthPanelPage.jsx";
import {Messages} from "../../Messages.js";
import {iFrameMerchantService} from "../../services/IframeMerchantService.js";
import {MessageElement} from "../../widget/ui/MessageElement.jsx";


export class DonationAuthPage extends AuthPanelPage {
    render() {
        return [
            Messages.merchantUsesBlinkForDonations.toString().trim() &&
                <MessageElement
                    message={Messages.merchantUsesBlinkForDonations(iFrameMerchantService.getMerchant().name)}
                    className={this.styleSheet.message}
                />,
            super.render()
        ];
    }
}
